import { create } from 'zustand';

interface TermsGateState {
  /** Forces the gate to re-check pending docs — set by the 403 backstop. */
  forceCheckToken: number;
  /** Keys of SOFT documents the user dismissed this session. */
  dismissedSoftKeys: string[];
  forceCheck: () => void;
  dismissSoft: (key: string) => void;
}

const useTermsGateStore = create<TermsGateState>((set) => ({
  forceCheckToken: 0,
  dismissedSoftKeys: [],
  forceCheck: () => set((s) => ({ forceCheckToken: s.forceCheckToken + 1 })),
  dismissSoft: (key) => set((s) => ({ dismissedSoftKeys: [...s.dismissedSoftKeys, key] })),
}));

/** Token that increments when a 403 CONSENT_REQUIRED forces a re-check. */
export const useTermsForceCheckToken = () => useTermsGateStore((s) => s.forceCheckToken);

/** Imperatively force the gate to refetch pending documents. */
export const useForceTermsCheck = () => useTermsGateStore((s) => s.forceCheck);

/** SOFT documents dismissed this session. */
export const useDismissedSoftKeys = () => useTermsGateStore((s) => s.dismissedSoftKeys);

/** Dismiss a SOFT document's banner for this session. */
export const useDismissSoft = () => useTermsGateStore((s) => s.dismissSoft);

/** Non-hook accessor for the interceptor (outside React). */
export const forceTermsCheckImperative = () => useTermsGateStore.getState().forceCheck();
